import { Box, Text, VStack } from '@chakra-ui/react';
import { FaChartBar } from '@react-icons/all-files/fa/FaChartBar';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import { FaFileSignature } from '@react-icons/all-files/fa/FaFileSignature';
import { FaUsers } from '@react-icons/all-files/fa/FaUsers';

import MarketplaceCard from '../MarketplaceCard';
import { PayoffTooltipIcon } from '../PayoffTooltipCopy';
import WhatHappensNextSteps, { Step } from '../WhatHappensNextSteps';

type AlmostLivePanelProps = {
  waitingSentence: string | null;
};

const AlmostLivePanel = ({ waitingSentence }: AlmostLivePanelProps) => {
  const isPayoffConfirmed = waitingSentence == null;

  const steps: Step[] = [
    {
      icon: FaCheck,
      title: 'We confirm your payoff',
      isActive: !isPayoffConfirmed,
      desc: (
        <Text as="span">
          {waitingSentence ??
            "Confirmed straight from your lienholder, that's the number every offer is built on."}{' '}
          <Box as="span" display="inline-block" verticalAlign="text-bottom">
            <PayoffTooltipIcon />
          </Box>
        </Text>
      ),
    },
    {
      icon: FaChartBar,
      title: 'Understand your options',
      desc: "Your confirmed payoff and where you stand. If selling makes sense, your listing goes live. If it doesn't, we'll help you figure out your next move.",
    },
    {
      icon: FaUsers,
      title: 'Buyers make offers',
      desc: 'We text you when an offer comes in. Accepting your favorite closes out the rest.',
    },
    {
      icon: FaFileSignature,
      title: 'You sign. The buyer picks up your car.',
      desc: 'Upload a few documents and sign from a link we send you. Your payoff is handled as part of the sale, and any difference settles around signing.',
    },
  ];

  return (
    <MarketplaceCard header="What happens next">
      <VStack spacing={5} align="stretch" px={{ base: '18px', md: '24px' }} py="22px">
        <Box>
          <Text
            fontSize={{ base: '18px', md: '22px' }}
            fontWeight="700"
            color="leaseEndBlue"
            lineHeight="1.2"
          >
            {isPayoffConfirmed
              ? 'Your listing is ready to go live.'
              : 'Your listing is ready. One thing left.'}
          </Text>
          <Text fontSize="13.5px" color="charcoal" lineHeight="1.55" mt={1}>
            {isPayoffConfirmed
              ? 'Your payoff is confirmed, so every number you see is real.'
              : "We're confirming your payoff so every number you see is real."}
          </Text>
        </Box>
        <WhatHappensNextSteps size="md" steps={steps} />
      </VStack>
    </MarketplaceCard>
  );
};

export default AlmostLivePanel;
